import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {passwordStrengthValidator, requiredFieldValidator} from 'common-domain';
import {TldManagerUserService} from '../../../user/services/tld-manager-user.service';


@Component({
    selector: 'create-password',
    templateUrl: './create-password-component.html',
    styleUrls: ['./create-password-component.scss'],
    standalone: false
})
export class CreatePasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  errorMessage: string;

  @Input()
  createMode: boolean;

  @Input()
  correlationId: string;

  @Input()
  mfaToken: string;

  @Output()
  resetPasswordCompleted = new EventEmitter<boolean>();

  error: any;

  constructor(private formBuilder: FormBuilder, private tldManagerUserService: TldManagerUserService) {
  }

  ngOnInit() {
    this.createForm();
  }

  onSubmit() {
    this.error = null;
    if (this.validateForm()) {
      this.tldManagerUserService.resetOrCreatePassword(this.resetPasswordForm.getRawValue().newPassword, this.correlationId, this.createMode, this.mfaToken).subscribe(data => {
      }, error => {
        this.error = error;
      }, () => {
        this.resetPasswordCompleted.emit(true);
      });
    }
  }

  cancel() {
    this.resetPasswordCompleted.emit(false);
  }


  private validateForm(): boolean {
    if (this.resetPasswordForm.getRawValue().newPassword !== this.resetPasswordForm.getRawValue().verifyNewPassword) {
      this.errorMessage = 'Passwords do not match.';
      this.resetPasswordForm.setErrors({invalid: true});
      return false;
    }
    return true;
  }

  private createForm() {
    this.errorMessage = '';
    this.error = null;
    this.resetPasswordForm = this.formBuilder.group({
      newPassword: new FormControl('', [requiredFieldValidator, passwordStrengthValidator]),
      verifyNewPassword: new FormControl('', [requiredFieldValidator]),
    });
  }

}
